import { render, staticRenderFns } from "./Idiomas.vue?vue&type=template&id=fb94a636&scoped=true&"
import script from "./Idiomas.vue?vue&type=script&lang=js&"
export * from "./Idiomas.vue?vue&type=script&lang=js&"
import style0 from "./Idiomas.vue?vue&type=style&index=0&id=fb94a636&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb94a636",
  null
  
)

export default component.exports